import React from 'react'
import { Col, Row, Space } from 'antd'
import { InstagramOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';

const FooterLayout = () => {
  const { phrases } = useSelector(({ polyglot }) => polyglot)

  if (phrases) {
    const {
      layouts: { footer, address }, components: { nav }
    } = phrases
    return (
      <div className='mpx-footer'>
        <div className='mpx-container'>
          <Row gutter={7.5}>
            <Col xs={24} lg={6}>
              <Space size={35} direction='vertical' style={{ marginBottom: '30px' }}>
                <div className='mpx-footer--logo'>
                  {/* <img src='/images/logo/logo footer.png' alt='MPX | LOGO' /> */}
                  <img src='/images/logo/logo-mpxl-white.png' alt='MPX | LOGO' />
                </div>
              </Space>
            </Col>
            <Col xs={24} lg={6}>
              <div className='mpx-footer--address' style={{ marginBottom: '20px' }}>
                <strong>{footer.lampung}</strong>
                <p  dangerouslySetInnerHTML={{ __html: address.lampung }} />
              </div>
              <div className='mpx-footer--address' style={{ marginBottom: '20px' }}>
                <strong>{footer.jakarta}</strong><br />
                <p dangerouslySetInnerHTML={{ __html: address.jakarta }} />
              </div>
              <div className='mpx-footer--address' >
                <strong>{footer.cilegon}</strong><br />
                <p dangerouslySetInnerHTML={{ __html: address.cilegon }} />
              </div>
            </Col>
            <Col xs={24} lg={6}>
              <div className='mpx-footer--address' style={{ marginBottom: '20px' }}>
                <strong>{footer.bogor}</strong><br />
                <p dangerouslySetInnerHTML={{ __html: address.bogor }} />
              </div>



              <div className='mpx-footer--address'>
                <strong>{footer.samarinda}</strong><br />
                <p dangerouslySetInnerHTML={{ __html: address.samarinda }} />
              </div>
            </Col>
            <Col xs={24} lg={4}>
              <h3>
                {nav.aboutUs.aboutUs}
              </h3>
              <Space direction='vertical' style={{ marginBottom: '30px' }} size={5}>
                <Link to='/profil-perusahaan'>
                  {nav.aboutUs.companyProfile}
                </Link>
                <Link to='/struktur-perusahaan'>
                  {nav.aboutUs.companyStructure}
                </Link>
                <Link to='#'>
                  {nav.aboutUs.awards}
                </Link>
                <Link to='#'>
                  {nav.aboutUs.career}
                </Link>
                <Link to='/hubungi-kami'>
                  {nav.aboutUs.contactUs}
                </Link>
              </Space>
            </Col>

            <Col xs={24} lg={2}>
              <h3>
                {nav.governance.governance}
              </h3>
              <Space direction='vertical' style={{ marginBottom: '30px' }} size={5}>
                <Link to='/piagam'>
                  {nav.aboutUs.charter}
                </Link>
              </Space>

              <div className='mpx-footer--contact'>
                  <h3>
                    {footer.stayConnected}
                  </h3>
                  <Space>
                    {/* <a href='https://instagram.com/mpx_id?igshid=YmMyMTA2M2Y=' target='_blank' className='icon' rel="noreferrer">
                      <InstagramOutlined style={{ fontSize: '20px' }} />
                    </a> */}
                    <a href='https://www.instagram.com/mpxlogistics/?igshid=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr' target='_blank' className='icon' rel="noreferrer">
                      <InstagramOutlined style={{ fontSize: '20px' }} />
                    </a>
                  </Space>
                </div>
            </Col>
          </Row>
          <div className='mpx-footer--copyright'>
            &copy; Copyright 2022. PT. MPX Logistics International Tbk
          </div>
        </div>
      </div>
    );
  } else {
    return false
  }
}

export default FooterLayout;